import React from 'react';
import { Button } from 'src/components/button';

export const TEST_ID_ADD_IMAGE_BANNER = 'add-image-banner';

type AddImageBannerProps = {
  disabled: boolean;
  addImageModal: () => void;
};

export function AddImageBanner({ disabled, addImageModal }: AddImageBannerProps): JSX.Element {
  return (
    <Button disabled={disabled} onClick={() => addImageModal()} data-testid={TEST_ID_ADD_IMAGE_BANNER}>
      Add Image Banner
    </Button>
  );
}
